import { SVGProps } from 'react';

const DotsScaleSmall = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M7.33301 5C7.33301 5.55228 6.88529 6 6.33301 6C5.78072 6 5.33301 5.55228 5.33301 5C5.33301 4.44772 5.78072 4 6.33301 4C6.88529 4 7.33301 4.44772 7.33301 5Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M7.33309 8C7.33309 8.55228 6.88537 9 6.33309 9C5.7808 9 5.33309 8.55228 5.33309 8C5.33309 7.44772 5.7808 7 6.33309 7C6.88537 7 7.33309 7.44772 7.33309 8Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M7.33309 11C7.33309 11.5523 6.88537 12 6.33309 12C5.7808 12 5.33309 11.5523 5.33309 11C5.33309 10.4477 5.7808 10 6.33309 10C6.88537 10 7.33309 10.4477 7.33309 11Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M10.6663 5C10.6663 5.55228 10.2186 6 9.66634 6C9.11406 6 8.66634 5.55228 8.66634 5C8.66634 4.44772 9.11406 4 9.66634 4C10.2186 4 10.6663 4.44772 10.6663 5Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M10.6663 8C10.6663 8.55228 10.2185 9 9.66626 9C9.11398 9 8.66626 8.55228 8.66626 8C8.66626 7.44772 9.11398 7 9.66626 7C10.2185 7 10.6663 7.44772 10.6663 8Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M10.6663 11C10.6663 11.5523 10.2185 12 9.66626 12C9.11398 12 8.66626 11.5523 8.66626 11C8.66626 10.4477 9.11398 10 9.66626 10C10.2185 10 10.6663 10.4477 10.6663 11Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
    </svg>
);
export default DotsScaleSmall;
